<div class="card" [class]="'dose-' + getSafeDoseType()" [ngStyle]="cachedGradientStyle" style="width: 18rem;">
  <img [src]="cachedImageUrl" 
       [alt]="localizedName" 
       class="card-img-top" 
       (error)="onImageError($event)"
       loading="lazy"
       decoding="async">
  <div class="card-body">
    <!-- <h5 class="card-title">{{ localizedName }}</h5> -->
    <p class="card-text text-center">{{ localizedDescription }}</p>
    <button class="btn btn-primary" (click)="viewDetails(product)">
      {{ readMoreText }} →
    </button>
  </div>
</div>
